function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104.633 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.25827
    },
    d: "M 44.398324,1.7117141 C 43.730752,1.3440445 11.557641,0.84698788 10.741201,1.1917299 c -0.318612,0.1345336 -0.8976118,0.1455025 -1.3524198,0.02562 -0.437407,-0.115296 -2.683689,-0.200817 -4.991737,-0.190048 -2.308047,0.01077 -4.26129904,-0.04197 -4.34055704,-0.11720002 -0.07926,-0.07523 -0.07452,-0.308896 0.01052,-0.519258 0.136396,-0.337375 1.55476904,-0.365264 12.02833584,-0.236496 6.530538,0.08028 15.929672,0.167805 20.886965,0.19448 5.474048,0.02945 9.741919,0.165504 10.868928,0.346471 2.522823,0.40509602 5.159824,0.38180902 7.633101,-0.06741 2.602969,-0.472771 53.148993,-0.871991 53.148993,-0.448911 0,0.461253 -1.62553,0.655443 -5.036819,0.601711 C 93.526709,0.68507888 52.675814,1.1885959 51.387188,1.6144935 49.993704,2.0750479 45.179617,2.142013 44.39832,1.7117105 Z",
    id: "path2551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingBottom);
export default __webpack_public_path__ + "static/media/headingBottom.c763783dbec8fd5ef4e5dfb8cc2cc3e8.svg";
export { ForwardRef as ReactComponent };